import axios from 'axios';

const config = {
  url: 'https://api.monday.com/v2',
  board_id: 5896130582,
  group_id: 'topics',
  // Extra value //
  category_id: 'single_select',
  budget_range_id: 'single_select0',
  status_id: 'Status',
  company_id: 'lead_company',
  title_id: 'text',
  email_id: 'lead_email',
  phone_id: 'lead_phone',
  location_id: 'location',
  message_id: 'message_id',
};

export const sendMondayApi = async (data) => {
  let result = null;
  const { name, email, message } = data;

  const mondayApiUrl = config.url;
  const board_id = config.board_id;
  const group_id = config.group_id;

  const column_values = JSON.stringify({
    // status: "0",
    [config.email_id]: email,
    [config.message_id]: message,
  });

  let query = `mutation {
      create_item (
        board_id: ${board_id},
        group_id: "${group_id}",
        item_name: "${name}",
        column_values: ${JSON.stringify(column_values)}
      ) { id }
    }`;

  try {
    const mondayApiResponse = await axios.post(
      mondayApiUrl,
      {
        query: query,
      },
      {
        headers: {
          // "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          Authorization: `${process.env.NEXT_PUBLIC_MONDAY_API_TOKEN}`,
        },
      }
    );
    result = mondayApiResponse;
  } catch (err) {
    console.log('Monday API Post Error', err);
  }

  return result;
};
